import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// ── QUE SHA ESTOY EJECUTANDO ───────────────────────────────────────────────
//
// Una sola linea en la consola responde a la pregunta que costo una auditoria
// entera: `window.__FERIA_BUILD_SHA__`.
//
// No es UI: no se pinta, no se anuncia y nadie tiene que mantenerlo. Sale del
// commit del build, y si el build no supo cual era dice `unknown` en vez de
// mentir. Tambien va en un `<meta>` del HTML, para poder leerlo sin ejecutar JS.
window.__FERIA_BUILD_SHA__ = process.env.REACT_APP_BUILD_SHA || 'unknown';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
